module.exports = __webpack_public_path__ + "media/images/nicklpass-icon-6e8839bdcb022e3fcd43d5dbd820c474.svg";